import { t } from '@lingui/macro';

import { FilterValues, PeoplePageParamKeys, SortValues } from './customPeopleTagTypes';

export const FILTER_BY_LIST_OPTIONS = [
  { key: FilterValues.All, label: t`All` },
  { key: FilterValues.Tagged, label: t`Tagged` },
  { key: FilterValues.Untagged, label: t`Untagged` },
];

export const SORT_BY_LIST_OPTIONS = [
  { key: SortValues.UploadDateNewest, label: t`Upload date (newest)` },
  { key: SortValues.UploadDateOldest, label: t`Upload date (oldest)` },
  { key: SortValues.FrequencyMost, label: t`Frequency (appears most)` },
  { key: SortValues.FrequencyLeast, label: t`Frequency (appears least)` },
  { key: SortValues.NameAscending, label: t`Name (A-Z)` },
  { key: SortValues.NameDescending, label: t`Name (Z-A)` },
];

const createOptionMap = (options: { key: string; label: string }[]): Record<string, string> =>
  options.reduce((obj, item) => (obj[item.key] = item.label, obj), {});

export const filterByMap = createOptionMap(FILTER_BY_LIST_OPTIONS);
export const sortByMap = createOptionMap(SORT_BY_LIST_OPTIONS);

export const EMPTY_STATE = {
  [FilterValues.All]: {
    heading: t`Gathering people from your photos...`,
    subheading: t`People who are in this Brandfolder’s photos will appear here. Check back soon to view and tag these people.`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/s5h36khcc9n499bn2fkhcm/people.svg?auto=webp&format=svg'
  },
  [PeoplePageParamKeys.Search]: {
    heading: t`No results found`,
    subheading: t`We couldn’t find a person with this name. They may not have been tagged yet, or if you recently uploaded assets, the photos may not have been processed for tagging.`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/khsnqnp7k75jmt9qpvf2zhv/ghosts.svg?auto=webp&format=svg'
  },
  [FilterValues.Tagged]: {
    heading: t`No tagged people`,
    subheading: t`People who have been tagged with a name will appear here.`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/khsnqnp7k75jmt9qpvf2zhv/ghosts.svg?auto=webp&format=svg'
  },
  [FilterValues.Untagged]: {
    heading: t`No untagged people`,
    subheading: t`You’ve identified everyone in this Brandfolder’s photos.`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/9gnrpsj4mjskfh875j5jb5v/checks.svg?auto=webp&format=svg'
  }
};
